export const UPDATE_MODAL = "UPDATE_MODAL";
